<template lang="pug">
    .browse-games-wrapper
        .browse-games-wrapper__header
            | {{ $i18n.t('trainer.trainer_main_freeGame') }}
        .browse-games-wrapper__body
            template(v-if='!isLoading')
                .course-selector(
                    v-if="pointsAccesses.length > 1 && (user.type !== 'student' && user.type !== 'olympiad-student')"
                )
                    .course-selector__buttons
                        cs-button.cs-button--selector(
                            v-for="(access, index) in pointsAccesses"
                            :key="access"
                            @click="selectGamesType(access)"
                            :class="{\
                                'cs-button--active-selector': pointsAccess === access,\
                            }"
                            :disabled="forbiddenAccesses.includes(access)"
                        )
                            | {{ $i18n.t('common.common_course_' + access) }}
                    .course-selector__multiselect
                        cs-multiselect(
                            :multiple="false"
                            :options="pointsAccesses"
                            v-model="pointsAccess"
                            :custom-label="courseName"
                            :placeholder="courseName(pointsAccess)"
                            :hide-selected="true"
                        )
                .browse-games-wrapper__header.course-selector(:style="{color: '#333333'}")
                    | {{ $i18n.t('trainer.trainer_main_mainGames') }}
                .row.game-cards(v-if="areGamesAvailable" )
                    .col-xs-12.col-md-6.col-xl-4.game-card(v-for='game in currentCourseGames', v-if="!game.isBonusGame")
                        router-link.game-card__link(
                            :to=`{
                                name: 'create:game',
                                query: {slug: game.slug},
                                params: {gamesType: currentCourseType}
                            }`
                        )
                            .game-card__inner
                                img.game-card__img(:src='game.img')
                                .game-card__text(v-html='game.text')
                .browse-games-wrapper__header.course-selector(v-if="!hideBonusGames && currentCourseType !== 'russianLanguage'" :style="{color: '#333333'}")
                    | {{ $i18n.t('trainer.trainer_main_bonusGames') }}
                .row.game-cards(v-if="!hideBonusGames && areGamesAvailable && currentCourseType !== 'russianLanguage'" )
                    .col-xs-12.col-md-6.col-xl-4.game-card(v-for='game in currentCourseGames', v-if="game.isBonusGame")
                        .game-card__link(
                            :style="{'cursor': 'pointer'}"
                            @click="checkAccessForBonusGame(game)"
                        )
                            .game-card__inner
                                img.game-card__img(:src='game.img')
                                .game-card__text(v-html='game.text')
                .not-available-game(v-if="!areGamesAvailable")
                    | {{ $i18n.t('trainer.trainer_games_noAvailableGames') }}
            cs-loader(v-else='')
        cs-modal(v-if="isModalOpened" :is-blur="true" @close="closeModal")
            slot
                | {{ $i18n.tc('trainer.trainer_gameList_bonusAccess',  studentAmountOnCourse) + " " }}
                a(href="https://cleverstart.omnidesk.ru/knowledge_base/item/281155" target="_blank") https://cleverstart.omnidesk.ru/knowledge_base/item/281155
</template>

<script>
    import HomeworkApi from '../../api/homework/homework';
    import TrainerConfig from '../../config/trainer.json';

    import BillingBlockMixin from '../../utils/user/BillingBlockMixin';

    import _ from 'lodash';
    import { mapState } from 'vuex';
    import { checkUserRouteAccess } from '@/utils/tariffHelper';
    import { TARIFF_IDS_WITH_BONUS_GAMES_HIDED } from '@/config/tariff_constants';

    const ALL_GAMES = function() {
        return TrainerConfig.games.map(({ slug, label, isBonusGame, courseType, img }) => ({
            slug,
            img,
            text: this.$i18n.t(label),
            courseType,
            isBonusGame,
            isBonusGameHasAccess: false,
        }));
    };
    export default {
        mixins: [BillingBlockMixin],
        data() {
            return {
                isLoading: false,
                homeworks: [],
                pointsAccesses: [],
                pointsAccess: '',
                forbiddenAccesses: [],
                studentAmountOnCourse: 0,
                isModalOpened: false,
            };
        },
        ALL_GAMES: [],
        beforeRouteEnter(to, from, next) {
            next(self => {
                if (from.params.gamesType && self.user.pointsAccesses.length > 1) {
                    self.pointsAccess = from.params.gamesType;
                }
                if (self.lessonConductingTemplate) {
                    self.$store.dispatch('setLessonConductingTemplate', null);
                }
            });
        },
        mounted() {
            this.checkIfUserHasAccessToGamesPage();
            this.$options.ALL_GAMES = ALL_GAMES.call(this);
            if (!this.$offline) {
                this.isLoading = true;
                HomeworkApi.uncompletedHomework()
                    .then(response => {
                        this.homeworks = _.orderBy(response.homeworks, 'date');
                        this.pointsAccesses = this.user.pointsAccesses;
                        if (this.uncompletedHomeworksTypes.length !== this.pointsAccesses.length) {
                            if (this.uncompletedHomeworksTypes.includes('mental-arithmetic')) {
                                this.forbiddenAccesses.push('mentalArithmetic');
                            }
                            if (this.uncompletedHomeworksTypes.includes('fast-reading')) {
                                this.forbiddenAccesses.push('fastReading');
                            }
                            if (this.uncompletedHomeworksTypes.includes('online-school')) {
                                this.forbiddenAccesses.push('onlineSchool');
                            }
                            if (this.uncompletedHomeworksTypes.includes('math-magic')) {
                                this.forbiddenAccesses.push('mathMagic');
                            }
                            if (this.uncompletedHomeworksTypes.includes('memory-development')) {
                                this.forbiddenAccesses.push('memoryDevelopment');
                            }
                            if (this.uncompletedHomeworksTypes.includes('multiplication')) {
                                this.forbiddenAccesses.push('multiplication');
                            }
                            if (this.uncompletedHomeworksTypes.includes('reading-en')) {
                                this.forbiddenAccesses.push('readingEn');
                            }
                            if (this.uncompletedHomeworksTypes.includes('russian-language')) {
                                this.forbiddenAccesses.push('russianLanguage');
                            }
                            if (!this.pointsAccess) {
                                this.pointsAccess =
                                    this.pointsAccesses.find(access => !this.forbiddenAccesses.includes(access)) || '';
                            }
                        }
                        if (this.$route.params.gamesType && this.user.pointsAccesses.length > 1) {
                            this.pointsAccess = this.$route.params.gamesType;
                        }
                        this.isLoading = false;
                    })
                    .catch(() => {
                        this.isLoading = false;
                    });
            }
            if (this.user && !this.user.isSuperadmin && !this.user.isManagerOrSupport) {
                this.determineBlockedAccesses();
                this.filterGames();
            }
        },
        methods: {
            checkIfUserHasAccessToGamesPage() {
                const { hasLimitTariff, noPlaytimeLeft, adminCantAccess } = checkUserRouteAccess(
                    this.user,
                    this.$route.name
                );
                if (hasLimitTariff && noPlaytimeLeft) {
                    return this.$router.push({ name: 'user:playtime-ended' });
                }

                if (adminCantAccess) {
                    return this.$router.push({ name: '403' });
                }
            },
            closeModal() {
                this.isModalOpened = false;
            },
            checkAccessForBonusGame(game) {
                this.$router.push({
                    name: 'create:game',
                    query: { slug: game.slug },
                    params: { gamesType: this.currentCourseType },
                });
            },
            filterGames() {
                this.$options.ALL_GAMES = this.$options.ALL_GAMES.filter(game =>
                    this.availableGames.includes(game.slug)
                );
            },
            determineBlockedAccesses() {
                this.forbiddenAccesses.push(...this.blockedAccesses);
                this.pointsAccess = this.pointsAccesses.find(access => !this.forbiddenAccesses.includes(access)) || '';
            },
            selectGamesType(access) {
                if (!this.forbiddenAccesses.includes(access)) {
                    this.pointsAccess = access;
                }
            },
            courseName(course) {
                return this.$i18n.t('common.common_course_' + course);
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                selectedCourse: state => state.trainer.course,
                lessonConductingTemplate: state => state.trainer.lessonConductingTemplate,
            }),
            hideBonusGames() {
                if (this.user.isSuperadmin || this.user.isManagerOrSupport) {
                    return false;
                }
                if (this.user.schools[0].isBonusGamesActive) {
                    return false;
                }
                if (TARIFF_IDS_WITH_BONUS_GAMES_HIDED.includes(this.user.schools[0].tariffId)) {
                    return true;
                }
                return true;
            },
            currentCourseType() {
                return ['student', 'olympiad-student'].includes(this.user.type)
                    ? this.selectedCourse
                    : this.pointsAccess;
            },
            currentCourseGames() {
                const currentCourseTypeKebab = _.kebabCase(this.currentCourseType);
                return this.$options.ALL_GAMES.filter(({ courseType }) => courseType === currentCourseTypeKebab);
            },
            areGamesAvailable() {
                return (
                    !this.areSchoolsBlocked &&
                    (this.$offline ||
                        this.user.type !== 'student' ||
                        !this.forbiddenAccesses.includes(this.selectedCourse)) &&
                    !this.pointsAccesses.every(access => this.forbiddenAccesses.includes(access))
                );
            },
            uncompletedMentalArithmeticHomework() {
                return this.homeworks.find(homework => {
                    if (!homework.isBlocked && homework.grades[0].course.type === 'mental-arithmetic') {
                        return homework;
                    }
                });
            },
            uncompletedFastReadingHomework() {
                return this.homeworks.find(homework => {
                    if (!homework.isBlocked && homework.grades[0].course.type === 'fast-reading') {
                        return homework;
                    }
                });
            },
            uncompletedOnlineSchoolHomework() {
                return this.homeworks.find(homework => {
                    if (!homework.isBlocked && homework.grades[0].course.type === 'online-school') {
                        return homework;
                    }
                });
            },
            uncompletedMathMagicHomework() {
                return this.homeworks.find(homework => {
                    if (!homework.isBlocked && homework.grades[0].course.type === 'math-magic') {
                        return homework;
                    }
                });
            },
            uncompletedMemoryDevelopmentHomework() {
                return this.homeworks.find(homework => {
                    if (!homework.isBlocked && homework.grades[0].course.type === 'memory-development') {
                        return homework;
                    }
                });
            },
            uncompletedMultiplicationHomework() {
                return this.homeworks.find(homework => {
                    if (!homework.isBlocked && homework.grades[0].course.type === 'multiplication') {
                        return homework;
                    }
                });
            },
            uncompletedReadingEnHomework() {
                return this.homeworks.find(homework => {
                    if (!homework.isBlocked && homework.grades[0].course.type === 'reading-en') {
                        return homework;
                    }
                });
            },
            uncompletedRussianLanguageHomework() {
                return this.homeworks.find(homework => {
                    if (!homework.isBlocked && homework.grades[0].course.type === 'russian-language') {
                        return homework;
                    }
                });
            },
            uncompletedHomeworksTypes() {
                let types = [];
                if (this.hasUncompletedHomework) {
                    if (this.uncompletedMentalArithmeticHomework) {
                        types.push('mental-arithmetic');
                    }
                    if (this.uncompletedFastReadingHomework) {
                        types.push('fast-reading');
                    }
                    if (this.uncompletedOnlineSchoolHomework) {
                        types.push('online-school');
                    }
                    if (this.uncompletedMathMagicHomework) {
                        types.push('math-magic');
                    }
                    if (this.uncompletedMemoryDevelopmentHomework) {
                        types.push('memory-development');
                    }
                    if (this.uncompletedMultiplicationHomework) {
                        types.push('multiplication');
                    }
                    if (this.uncompletedReadingEnHomework) {
                        types.push('reading-en');
                    }
                    if (this.uncompletedRussianLanguageHomework) {
                        types.push('russian-language');
                    }
                }
                return types;
            },
            hasUncompletedHomework() {
                return this.homeworks.filter(homework => !homework.isBlocked).length;
            },
            availableGames() {
                if (!this.user || (!this.user.school && !(this.user.schools && this.user.schools.length))) {
                    return [];
                }
                let games = [];
                if (this.user.type === 'admin') {
                    if (this.user.schools && this.user.schools.length >= 1) {
                        this.user.schools.forEach(school => {
                            school.courses.forEach(course => {
                                if (course.status === 'active') {
                                    games.push(...course.games);
                                }
                            });
                        });
                    } else if (this.user.school) {
                        this.user.school.courses.forEach(course => {
                            if (course.status === 'active') {
                                games.push(...course.games);
                            }
                        });
                    }
                }
                if (
                    (this.user.type === 'student' || this.user.type === 'teacher') &&
                    this.user.grades &&
                    this.user.grades.length >= 1
                ) {
                    this.user.grades.forEach(grade => {
                        if (grade.status === 'active' && grade.course && grade.course.status === 'active') {
                            games.push(...grade.course.games);
                        }
                    });
                }
                if (this.user.type === 'student' && games.length && games.some(game => game.slug === 'Presentations')) {
                    games = games.filter(game => game.slug !== 'Presentations');
                }
                this.$options.ALL_GAMES.forEach(game => {
                    if (game.isBonusGame) {
                        games.push(game);
                    }
                });
                if (games.length !== 0) {
                    return _.uniqBy(games, 'slug').map(game => game.slug);
                }
                return [];
            },
        },
    };
</script>

<style scoped lang="scss">
    .blur-game-cards {
        filter: blur(2px);
    }

    .browse-games-wrapper {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin: 0;
        padding: 10px;
        height: 100%;
        background-color: $x-color-white;
        box-sizing: border-box;
        @include media($sm) {
            padding: 15px;
            border-radius: $border-radius-40;
        }
    }

    .browse-games-wrapper__header {
        padding: 10px;
        font-family: Appetite, serif;
        font-style: normal;
        font-weight: normal;
        font-size: 32px;
        line-height: 32px;

        color: $hsl-color-blue-56;

        @include media($sm) {
            padding: 15px;
            font-size: 42px;
            line-height: 42px;
        }
    }

    .browse-games-wrapper__body {
        width: 100%;
    }

    .course-selector {
        display: flex;
        padding: 15px 10px;
        @include media($md) {
            padding: 15px 25px;
        }
        @include media($xl) {
            padding: 15px 85px;
        }
    }

    .course-selector__buttons {
        display: none;
        @include media($lg) {
            display: flex;
            flex: 1 1 auto;
            width: 800px;
            overflow-x: auto;
        }
    }

    .course-selector__multiselect {
        width: 100%;
        display: block;
        @include media($lg) {
            display: none;
        }
    }

    .game-cards {
        padding: 0;
        display: flex;
        justify-content: center;
    }

    .game-card {
        padding: 10px 15px;

        box-sizing: border-box;
        height: 193px;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        text-align: center;

        @include media($sm) {
            padding: 15px;
        }
    }

    .game-card__link {
        width: 100%;
        height: 100%;
        display: table;
        color: $x-color-black;
    }

    .game-card__inner {
        height: 100%;
        display: table-cell;
        vertical-align: middle;

        padding: 30px 0;
        box-sizing: border-box;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;
    }

    .game-card__img {
        max-height: 70px;
        height: auto;
        max-width: 100%;
    }

    .game-card__text {
        font-weight: 500;
        padding: 10px 6px 0 0;
    }

    .not-available-game {
        margin-top: 10px;
        text-align: center;
        font-size: 18px;
        color: $hsl-color-gray-20;
    }
</style>
